module.exports = __webpack_public_path__ + "media/images/marumotakagi/marumo-2b683fcd0022a834619a040466f204ee.gif";